const { formatMoney } = window.BAO.Utils

export class ProductSubtotal extends window.BAO.CustomElement() {
  static get observedAttributes () {
    return ['price', 'quantity']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  attributeChangedCallback (name, oldValue, newValue) {
    const isANumber = isNaN(parseInt(newValue, 10)) === false

    switch (name) {
      case 'price': {
        if (!isANumber) break
        if (parseInt(oldValue, 10) === parseInt(newValue, 10)) break

        this.handlePriceUpdateSideEffects(parseInt(newValue, 10))

        break
      }
      case 'quantity': {
        if (!isANumber) break
        if (parseInt(oldValue, 10) === parseInt(newValue, 10)) break

        this.handleQuantityUpdateSideEffects(parseInt(newValue, 10))

        break
      }
    }
  }

  setupListeners () {
    super.setupListeners()

    if (
      !this.hasAttribute('price') ||
      !this.hasAttribute('quantity') ||
      !this.productDetailBlocksEl
    ) {
      return
    }

    this.onQuantityUpdate = this.onQuantityUpdate.bind(this)
    this.onVariantChange = this.onVariantChange.bind(this)
    this.onLightingChange = this.onLightingChange.bind(this)

    this.listeners.add(
      this.productDetailBlocksEl,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.onQuantityUpdate,
    )

    this.listeners.add(
      this.productDetailBlocksEl,
      window.BAO.EVENTS.VARIANT.CHANGE,
      this.onVariantChange,
    )

    this.listeners.add(
      window.BAO.eventBus,
      window.BAO.EVENTS.LIGHTING.CHANGED,
      this.onLightingChange,
    )
  }

  onQuantityUpdate (event) {
    if (!event?.detail?.value) return
    this.currentQuantity = event.detail.value
  }

  onVariantChange (event) {
    if (!event?.detail?.variant?.data?.price) return
    this.currentPrice = event.detail.variant.data.price
  }

  onLightingChange (event) {
    if (event?.detail?.surcharge === undefined) return
    this._hasSelectedLightingOption = this.hasAttribute(
      'data-show-lighting-price',
    )
    this.currentSurcharge = event.detail.surcharge
  }

  handleQuantityUpdateSideEffects (quantity) {
    this.renderSubTotal(this.currentPrice * quantity)
  }

  handlePriceUpdateSideEffects (price) {
    this.renderSubTotal(price * this.currentQuantity)
  }

  renderSubTotal (subtotal) {
    const total = subtotal + this.currentSurcharge * this.currentQuantity
    this.innerHTML = `(${formatMoney(total)})`
  }

  get currentPrice () {
    return parseInt(this.getAttribute('price'), 10) || null
  }

  get currentQuantity () {
    return parseInt(this.getAttribute('quantity'), 10) || null
  }

  get currentSurcharge () {
    return parseInt(this.getAttribute('surcharge'), 10) || 0
  }

  set currentPrice (price) {
    this.setAttribute('price', String(price))
  }

  set currentQuantity (quantity) {
    this.setAttribute('quantity', String(quantity))
    this.setAttribute(
      'aria-hidden',
      String(quantity <= 1 && !this._hasSelectedLightingOption),
    )
  }

  set currentSurcharge (surcharge) {
    this.setAttribute('surcharge', String(surcharge))
    this.setAttribute(
      'aria-hidden',
      String(
        surcharge === 0 &&
          this.currentQuantity <= 1 &&
          !this._hasSelectedLightingOption,
      ),
    )
    this.renderSubTotal(this.currentPrice * this.currentQuantity)
  }

  get productDetailBlocksEl () {
    return this.closest('[data-product-detail-blocks]')
  }
}

if (!customElements.get('product-subtotal')) {
  customElements.define('product-subtotal', ProductSubtotal)
}
